export default "__VITE_ASSET__D2lCQYm6__"